import React, {useEffect, useState} from "react";
import "./MobileMenu.sass"
import ButtonComponent from "../../_components/common/buttons/ButtonComponent";
import {useDispatch, useSelector} from "react-redux";
import {IDLE, LOADING} from "../../common/statuses";
import {useNavigate} from "react-router";
import {ABOUT, COLLABORATION_PAGE, COURSES, LOGIN, MAIN, TEACHERS} from "../../common/links";
import {logout} from "../../_actions/auth/authService";
import {setEmpty as clearGroup} from "../../_actions/group/groupReducer";
import {clearHWState} from "../../_actions/student/hw/hwReducer";
import {clearGameState} from "../../_actions/game/gameReduce";
import {clearNotificationState} from "../../_actions/notification/notificationReducer";

export const MobileMenu = ({show, onHide}) => {
    const [hidden, setHidden] = useState(true);

    const {current: user, status} = useSelector(state => state.auth)

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (show) {
            setHidden(false);
        }
    }, [show])

    const handleClick = () => {
        setHidden(true)
        setTimeout(() => {
            onHide();
        }, 200)
    }

    if (!show) {
        return <></>
    }

    const handleButtonClick = (link) => {
        navigate(link);
        handleClick()
    }

    const handleLogout = () => {
        navigate(MAIN);
        dispatch(logout());
        dispatch(clearGroup());
        dispatch(clearHWState());
        dispatch(clearGameState());
        dispatch(clearNotificationState());
        handleClick();
    }


    return <div className="MobileMenu-wrapper" onClick={handleClick}>
        <div className={`MobileMenu-content ${!hidden ? "MobileMenu-content-visible" : ""}`}
             onClick={(e) => e.stopPropagation()}>
            <div className="MobileMenu-content-title">
                Меню
            </div>
            <div className="MobileMenu-content-common-buttons">
                <ButtonComponent onClick={() => handleButtonClick(MAIN)}>Главная</ButtonComponent>
            </div>
            <div className="MobileMenu-content-common-buttons">
                <ButtonComponent onClick={() => handleButtonClick(COURSES)}>Курсы</ButtonComponent>
                <ButtonComponent onClick={() => handleButtonClick(TEACHERS)}>Методисты</ButtonComponent>
                <ButtonComponent onClick={() => handleButtonClick(COLLABORATION_PAGE)}>Сотрудничество</ButtonComponent>
                <ButtonComponent onClick={() => handleButtonClick(ABOUT)}>О нас</ButtonComponent>
            </div>

            {
                (status !== IDLE || status !== LOADING)
                && <div className="MobileMenu-content-login-button">
                    <ButtonComponent onClick={user ? handleLogout : () => handleButtonClick(LOGIN)}>
                        {user ? "Выйти" : "Войти"}
                    </ButtonComponent>
                </div>
            }
        </div>
    </div>
}